import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'
import LandingPage from '../LandingPage/LandingPage';
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import RegistrationComplete from '../RegistrationComplete/RegistrationComplete';
import VerifyEmail from '../VerifyEmail/VerifyEmail';
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Route exact path='/' component={LandingPage} />
          <Route path='/register' component={RegistrationForm} />
          <Route path='/registrationComplete' component={RegistrationComplete} />
          <Route path='/verify' component={VerifyEmail} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js